// src/services/api.js
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';

const backendUrl = process.env.REACT_APP_MASTER_API_URL;

const masterApiCall = async (
    endpoint,
    useMock,
    method = "GET",
    body = null,
    startLoading,
    stopLoading,
    displayToast
) => {
    if (startLoading) startLoading(); // Activate global loader
    try {
        {
            console.log(`[LIVE API] ${method} ${backendUrl}${endpoint}`, "");
            const storedToken = sessionStorage.getItem("app_masterdata_token");

            const options = {
                method: method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${storedToken}`,
                },
            };

            // Only include body for non-GET/HEAD requests
            if (method !== "GET" && method !== "HEAD" && body) {
                options.body = JSON.stringify(body);
            }

            const response = await fetch(`${backendUrl}${endpoint}`, options);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            if (method === "DELETE") return { success: true };
            return await response.json();
        }
    } catch (error) {
        console.error(`Error fetching data from ${endpoint}:`, error);
        displayToast(
            `Failed to fetch data from ${endpoint}: ${error.message}`,
            "error"
        );
        throw error; // Re-throw to be caught by calling component
    } finally {
        if (stopLoading) stopLoading(); // Deactivate global loader
    }
};
export default masterApiCall;